import React from 'react';
import { Panel } from 'primereact/panel';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { useFormValidation } from '../../hooks/useFormValidation';
import Loader from '../sturtural/Loader';
import MessageDetail from '../sturtural/MessageDetail';

const DocumentFormValidation = ({ adjuntoid, url, handleHidden, handlerEdit, handlerAviso, documento }) => {
    
    const initialForm = {
        observaciones: "",
        mark: "",
    }
    
    const validationsFrom = (form) => {
        let errors = {};

        if(!form.mark) {
            errors.mark = "El Campo (Calificar el documento) es requerido";
        } else {
            if(form.mark.code === 'Rechazar') {
                if(!form.observaciones) {
                    errors.observaciones = "Si ha seleccionado Rechazar el documento el campo (observaciones) es obligatorio";
                }
            }
        }
    
        return errors;
    }
    
    const {form, 
        errors,
        loading,
        response,
        handleChange,
        handleBlur,
        handleSubmit} = useFormValidation(initialForm, validationsFrom, handleHidden, handlerEdit, handlerAviso, adjuntoid);

    const dropdownItemsMark = [
        {name: 'Rechazar', code: "Rechazar"},
        {name: 'Aprobar', code: "Aprobar"}
    ];
    
    return (
        <>
            <iframe
                title={documento}
                width="100%"
                height="620"
                src={url}>
            </iframe>
            <hr />
            
            <Panel>
                <form onSubmit={handleSubmit} className="col-12">
                    <h5>FAVOR DE REVISAR EXHAUSTIVAMENTE EL DOCUMENTO PARA VALIDAR QUE CUMPLA CON LOS REQUISITOS</h5>
                    <p>REQUISITO A VALIDAR: {documento}</p>
                    <div className="p-fluid formgrid grid">
                        <div className="field col-12 md:col-4">
                            <label htmlFor="mark">Calificar el documento:</label>
                            <Dropdown id="mark" name="mark" value={form.mark}  options={dropdownItemsMark} optionLabel="name" placeholder="Elige una opción" onChange={handleChange} onBlur={handleBlur} className={errors.mark && 'p-invalid'}></Dropdown>
                            {errors.mark && <small className="p-error">{errors.mark}</small>}
                        </div>
                        <div className="field col-12">
                            <label htmlFor="observaciones">Observaciones:</label>
                            <InputTextarea id="observaciones" name="observaciones" rows="2" value={form.observaciones.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.observaciones && 'p-invalid'} />
                            {errors.observaciones && <small className="p-error">{errors.observaciones}</small>}
                        </div>
                    </div>
                    <div className="p-dialog-footer">
                        {loading && <Loader />}
                        {response && <MessageDetail mensaje="La solicitud de a realizado correctamente." />}
                        {errors.adjuntoid && <small className="p-error">{errors.adjuntoid}</small>}
                        <Button type="submit" label="Aceptar" className="p-button-rounded p-button-success mr-2 mb-2" />
                    </div>
                </form>
            </Panel>
        </>
    );
};

export default DocumentFormValidation;